import type { ComponentType, ReactElement } from 'react';

import Authenticated from '@/layouts/Authenticated';
import Guest from '@/layouts/Guest';

// Rendered without any shell: the page carries its own.
const NO_LAYOUT_PAGES = ['auth/VerifyEmail'];

// Whole sections that supply their own full-page frame. The developer console is
// standalone chrome like /horizon, so DeveloperShell replaces Authenticated for
// every page under it, current and future.
const NO_LAYOUT_PREFIXES = ['developer/'];

/**
 * The persistent layout a resolved page component should be wrapped in, keyed
 * off the Inertia page name, or `null` for the pages that carry their own.
 *
 * Returned as an ARRAY because v3 probes a bare value assigned to `page.layout`
 * as a render function: our layout component would be called with the props
 * object where v2 called it with the page element. The array form is read as a
 * layout component, which is what these are.
 */
export function layoutFor(
  name: string,
): [ComponentType<{ children?: ReactElement }>] | null {
  if (NO_LAYOUT_PAGES.includes(name)) {
    return null;
  }

  if (NO_LAYOUT_PREFIXES.some((prefix) => name.startsWith(prefix))) {
    return null;
  }

  return [name.startsWith('auth/') ? Guest : Authenticated];
}
